import { render, staticRenderFns } from "./AttributeSelector.vue?vue&type=template&id=3c7391fa&scoped=true"
import script from "./AttributeSelector.vue?vue&type=script&lang=ts"
export * from "./AttributeSelector.vue?vue&type=script&lang=ts"
import style0 from "./AttributeSelector.vue?vue&type=style&index=0&id=3c7391fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7391fa",
  null
  
)

export default component.exports